import React, { useContext } from "react";
import FormContext from "../../context/FormContext";
import { Navbar, Sidebar } from "../allcomponents";
import "./layout.css";

function Layout({ children }) {
  const context = useContext(FormContext);
  const { sidebarToggle } = context;
  return (
    <React.Fragment>
      <div>
        <Navbar />
      </div>
      <div className="padding-content ">
        {sidebarToggle && (
          <div className="animate__animated animate__fadeInLeft ">
            <Sidebar />
          </div>
        )}

        <div className="content"> {children}</div>
      </div>
    </React.Fragment>
  );
}

export default Layout;
